import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Collapse } from "reactstrap";
import Typography from "storybookComponents/Typography"

const useStyles = makeStyles((theme) => ({
  subField: {
    padding: "0 30px",
    paddingRight: 8,
  },
  subFieldContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: "0.5rem",
  },
  tag: { background: "#F8F8F8", minWidth: 50, textAlign: "center", padding: "2px 0", border: "2px solid white" },
}));


const Tag = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.tag}>{children}</div>
}

const Invitee = ({ data, selected, onChange }) => {

  const [open, setOpen] = React.useState(selected.indexOf(`${data.name} (${data.reachableCount})`) > -1 ? true : false);

  const classes = useStyles();

  const handleChange = (evt) => {
    setOpen(evt.target.checked);
    onChange(`${data.name} (${data.reachableCount})`, evt.target.checked, data)
  }
  return (
    <div>
      <div id="CheckField" className={classes.subFieldContainer}>
        <FormControlLabel
          control={<Checkbox color="primary" onChange={handleChange} name={data.name} defaultChecked={selected.indexOf(`${data.name} (${data.reachableCount})`) > -1} />}
          label={data.name}
        />
        <Tag absolute >{data.count}</Tag>
      </div>
      <Collapse isOpen={open}>
        <div className={classes.subFieldContainer}>
          <Typography className={classes.subField}>- Events reachable </Typography>
          <Tag>{data.reachableCount}</Tag>
        </div>
        {
          data.mmsReachableCount ?
            <div className={classes.subFieldContainer}>
              <Typography className={classes.subField}>- SMS reachable </Typography>
              <Tag>{data.mmsReachableCount}</Tag>
            </div>
            : null
        }
      </Collapse>
    </div>
  )
}


export default Invitee